module.exports = __webpack_public_path__ + "static/media/user-white.fad8aa0f.svg";